import { Injectable } from '@angular/core';
import type {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Router } from '@angular/router';
import { Auth } from '@freelancer/auth';
import { delay, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ShellGuard implements CanActivate {
  constructor(private auth: Auth, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): ReturnType<CanActivate['canActivate']> {
    const shouldBeLoggedIn = route.data.loggedIn;
    return this.auth.isLoggedIn().pipe(
      switchMap(async isLoggedIn => {
        if (
          isLoggedIn !== shouldBeLoggedIn &&
          route.parent?.routeConfig?.children
        ) {
          // HACK: reverse the route config so the other route goes first
          // https://github.com/angular/angular/issues/16211
          route.parent.routeConfig.children.reverse();
          // then reload this route to access the reversed config
          // HACK 2: force the page to reload because we're doing a same url navigation
          this.router.onSameUrlNavigation = 'reload';
          // eslint-disable-next-line local-rules/no-navigate-in-guard
          this.router.navigateByUrl(state.url).then(() => {
            this.router.onSameUrlNavigation = 'ignore';
          });
        }
        return isLoggedIn === shouldBeLoggedIn;
      }),
      // Wait for route animations to play.
      delay(0),
    );
  }
}
